export const common = {
  // Navigation
  home: 'Home',
  product: 'Product',
  applications: 'Applications',
  aboutUs: 'About Us',
  contact: 'Contact',
  
  // Common Actions
  learnMore: 'Learn More',
  getStarted: 'Get Started',
  contactUs: 'Contact Us',
  sendMessage: 'Send Message',
  sending: 'Sending...',
  
  // Footer
  quickLinks: 'Quick Links',
  ourProduct: 'Our Product',
  followUs: 'Follow Us',
  poweredBy: 'Powered by Readdy',
  allRightsReserved: 'All rights reserved.',
  footerDescription: 'Engineering excellence in steel fiber reinforcement for the construction industry.',
  hookedEndSteelFibers: 'Hooked-End Steel Fibers',
  websiteBuilder: 'Website Builder',
  
  // Contact
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  whatsapp: 'WhatsApp',
  instagram: 'Instagram',
  
  // Form
  fullName: 'Full Name',
  companyName: 'Company Name',
  emailAddress: 'Email Address',
  phoneNumber: 'Phone Number',
  message: 'Message',
  required: '*',
  characters: 'characters',
  
  // Messages
  successMessage: 'Thank you! Your message has been sent successfully. We\'ll get back to you soon.',
  errorMessage: 'Sorry, there was an error sending your message. Please try again or contact us directly.',
};
